<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_color') || '面料颜色及花型'"
      visible
      direction="rtl"
      :size="800"
      @close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :fabricCode="fabricCode"
          :fabricColorCode="fabricColorCode"
          @reload="$emit('reload')"
          @close="close"
        />
      </div>
      <div class="drawer-footer">
        <el-button type="success" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    fabricCode: { type: String, default: '' },
    fabricColorCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
